<template>
  <div>
    <b-form-input :state="state.number"
                  type="text"
                  pattern="[0-9]*"
                  maxlength="20"
                  class="form-control m-input"
                  :placeholder="clientNumberPlaceholder"
                  name="number"
                  id="number"
                  autocomplete="off"
                  @input="onInput"
                  aria-describedby="numberFeedback"
                  v-model="number"></b-form-input>
    <b-form-invalid-feedback id="numberFeedback">
      {{ numberErrorMessage }}
    </b-form-invalid-feedback>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "CardNumberInput",
  props: {
    value: String,
    required: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      number: '',
      state: {
        number: null
      },
      numberErrorMessage: '',
    }
  },
  methods: {
    onInput(newVal) {
      this.$emit('input', newVal);
    },
    validate() {
      if (this.required && !this.number.length) {
        this.numberErrorMessage = this.$t('Must provide ') + this.clientNumberLabel;
        this.state.number = false;
        return;
      } else if ((this.required || this.number.length) && !this.number.match(/^\d+$/)) {
        this.numberErrorMessage = this.$t('Number contains invalid characters');
        this.state.number = false;
        return;
      } else if ((this.required || this.number.length) && this.number.length < 1) {
        this.numberErrorMessage = this.$t('Number too short');
        this.state.number = false;
        return;
      } else if ((this.required || this.number.length) && this.number.length > 20) {
        this.numberErrorMessage = this.$t('Number too long');
        this.state.number = false;
        return;
      }

      this.state.number = true;
    }
  },
  computed: {
    ...mapState({
      clientNumberLabel: state => state.settings.clientNumberLabel,
    }),
    clientNumberPlaceholder() {
      const base = this.clientNumberLabel || '';
      return this.required ? base : `${base} (${this.$t('optional')})`;
    }
  },
  watch: {
    value(newVal) {
      this.number = newVal;
      this.validate();
      this.$emit('input', newVal);
    },
    'state.number'(newVal) {
      if (newVal === true) {
        this.$emit('valid');
      }

      if (newVal === false) {
        this.$emit('invalid');
      }
    },
  }
}
</script>

<style scoped>
.m-input.form-control:focus:not(.is-invalid) {
  border-color: var(--accent-color) !important;
}
</style>
